import { State } from '../../reducers/rootReducer'
import ComparisonResultData from '../../../entities/ComparisonResultData'

const comparisonCarlineResultDataSelector = (state: State): ComparisonResultData | undefined => state.comparisonResultData

export default comparisonCarlineResultDataSelector
